var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{class:_vm.$vuetify.theme.dark ? '' : _vm.getBackgroundColor},[(_vm.company)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }